import type { EntityType } from '@tunasong/schemas'
import type { AgentDefinition } from './types.js'

const registry = new Map<string, AgentDefinition>()

/**
 * Register an agent definition. Idempotent — re-registering an id replaces
 * the prior entry. Matches `registerAgentCommand` semantics so plugin authors
 * can rely on a single mental model across registries.
 */
export const registerAgentDefinition = (def: AgentDefinition): void => {
  registry.set(def.id, def)
}

export const getAgentDefinition = (id: string): AgentDefinition | undefined => registry.get(id)

export const getAllAgentDefinitions = (): AgentDefinition[] => Array.from(registry.values())

export const getAgentDefinitionsForEntityType = (entityType: EntityType): AgentDefinition[] =>
  Array.from(registry.values()).filter(d => d.entityTypes.includes(entityType))

/** Test-only. Resets module-load state so suites can register from a known baseline. */
export const resetAgentDefinitionsForTests = (): void => {
  registry.clear()
}
